import { formataTelefone } from "../../funcoes/Funcoes";

import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

function Header({ contexto }) {
  const facebook =
    contexto.facebook && contexto.facebook !== ""
      ? contexto.facebook
      : "https://www.facebook.com/connectsaoficial/";
  const instagram =
    contexto.instagram && contexto.instagram !== ""
      ? contexto.instagram
      : "https://www.instagram.com/connectsaoficial/";
  const linkedin =
    contexto.linkedin && contexto.linkedin !== ""
      ? contexto.linkedin
      : "https://www.linkedin.com/company/connectsaoficial";
  const name = contexto.name;
  const telefoneFormatado = "61 3038-3595"; //formataTelefone(contexto.telefone);

  return (
    <div>
      {/* Sobmenu */}
      <div className="w-full py-[13px] bg-gradient-to-r from-[#1A2D8F] to-[#76D093]">
        <div className="w-10/12 mx-auto flex flex-row justify-between max-[787px]:justify-center">
          
          {/* Label some no mobile */}
          <div className="text-white text-[14px] max-[787px]:hidden">
            Agora os clientes da {name} podem adquirir seu certificado digital com desconto.
          </div>

          {/* Contato + ícones sociais */}
          <div className="text-white text-[14px] flex gap-2 items-center">
            Atendimento:
            <a href="#" className="text-white font-bold">
              {telefoneFormatado}
            </a>
            |

            <a href={facebook} target="_blank" className="pl-1 text-white">
              <FacebookIcon />
            </a>
            <a href={instagram} target="_blank" className="pl-1 text-white">
              <InstagramIcon />
            </a>
            <a href={linkedin} target="_blank" className="pl-1 text-white">
              <LinkedInIcon />
            </a>
          </div>
        </div>
      </div>

      {/* Header / Logo + Menu */}
      <div className="w-full py-10 bg-white">
        <div className="w-10/12 mx-auto grid grid-cols-1 md:grid-cols-2">

          {/* Logo */}
          <div className="flex justify-center md:justify-start">
            <img
              src="https://cdn-saturno.s3.amazonaws.com/saturno/connect/logo_connect_certificado.png"
              alt="logo-connect"
            />
          </div>

          {/* Menu */}
          <div className="flex justify-end items-center max-[787px]:hidden">
            <ul className="flex gap-3">
              <li>
                <a
                  href="#ecnpj"
                  className="bg-[#009881] text-white text-[15px] font-bold tracking-wider py-[14px] px-[19px] rounded-md hover:brightness-110 transition"
                >
                  e-CNPJ
                </a>
              </li>
              <li>
                <a
                  href="#ecpf"
                  className="bg-[#009881] text-white text-[15px] font-bold tracking-wider py-[14px] px-[19px] rounded-md hover:brightness-110 transition"
                >
                  e-CPF
                </a>
              </li>
              <li>
                <a
                  href="#nfe"
                  className="bg-[#009881] text-white text-[15px] font-bold tracking-wider py-[14px] px-[19px] rounded-md hover:brightness-110 transition"
                >
                  NF-e
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Header;
